import { Box } from '@mui/material'
import React, { useState } from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Sector } from 'recharts'

const CustomPieChart = (props) => {
  const { data = [], dimensions = {}, extras = {}, isAllChart = 0 } = props
  const { centerContent = '', bottomContent = '', topContent = '' } = props
  const { width = 300, height = 300 } = dimensions
  const total = data.reduce((sum, entry) => sum + entry.value, 0)
  const noData = !total
  const defaultData = [{ name: 'No Data Available', value: 1, color: '#e4e4e4' }]
  const { className = '' } = extras
  const [activeIndex, setActiveIndex] = useState(null)
  const onPieEnter = (_, index) => {
    setActiveIndex(index)
  }
  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill } = props

    const offset = 5
    const sin = Math.sin(-RADIAN * midAngle)
    const cos = Math.cos(-RADIAN * midAngle)
    const dx = cos * offset
    const dy = sin * offset

    return (
      <g transform={`translate(${dx}, ${dy})`}>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
      </g>
    )
  }
  const toolTipFormatter = (value, name) => {
    if (noData) {
      return [name]
    }
    const percent = ((value / total) * 100).toFixed(1)
    return [`${percent}% (${value})`, name]
  }
  return (
    <Box
      sx={{
        position: isAllChart === 0 ? 'relative' : '',
        display: 'flex',
        flexDirection: isAllChart === 0 ? 'column' : 'row',
        alignItems: 'center',
      }}
      className={`pie-chart-component ${className}`}
    >
      <Box className={`pie-top-box-${isAllChart}`}>{topContent}</Box>
      <Box
        sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'space-evenly' }}
        onMouseLeave={() => setActiveIndex(null)}
        className='pie-legend-container'
      >
        <ResponsiveContainer width={width} height={height} minWidth={'175px'}>
          <PieChart width={width} height={height}>
            <Tooltip formatter={toolTipFormatter} />
            <Pie
              data={noData ? defaultData : data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius="100%"
              fill="#8884d8"
              activeIndex={activeIndex}
              onMouseEnter={onPieEnter}
              onMouseLeave={() => setActiveIndex(null)}
              activeShape={renderActiveShape}
            >
              {(noData ? defaultData : data).map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
          </PieChart>
          <Box className="pie-center-box">{centerContent}</Box>
        </ResponsiveContainer>
        {bottomContent ? <Box className={`pie-bottom-box-${isAllChart}`}>{bottomContent}</Box> : null}
      </Box>
    </Box>
  )
}

export default CustomPieChart
